import { useSelector } from "react-redux";
import style from "../../../sass/pages/shipment/shipment.module.scss";
import {} from "./shipmentItemsSlice";
import ShipmentItemTableRow from "./ShipmentItemTableRow";
import { selectShipment } from "../shipmentSlice";
import { useTranslation } from "react-i18next";
import { STANDARD_PACKAGE_TYPE } from "../../../data/static-data";

const ShipmentItemsTable = ({items, boxID}) => {
    const {t} = useTranslation();
    const shipment = useSelector(selectShipment)
    
    if(!items || items.length === 0) {
        return
    }

    return (
        <>
            {
                <div className="flex justify-center">
                    <table className={style.table}>
                        <thead>
                            <tr>
                                <th>
                                    <div className="inline-flex flex-col gap-0.5">
                                        <span>№</span>
                                    </div>
                                </th>
                                <th>
                                    <div className="inline-flex flex-col gap-0.5">
                                        <span>
                                            {t("shipment.items.table.header.name")}
                                        </span>
                                    </div>
                                </th>
                                <th>
                                    <div className="inline-flex flex-col gap-0.5">
                                        <span>
                                            {t("shipment.items.table.header.price")}
                                        </span>
                                    </div>
                                </th>
                                <th>
                                    <div className="inline-flex flex-col gap-0.5">
                                        <span>
                                            {t("shipment.items.table.header.count")}
                                        </span>
                                    </div>
                                </th>
                                {shipment && shipment["package-type"] === STANDARD_PACKAGE_TYPE && (
                                    <th className="hidden sm:table-cell">
                                        <div className="inline-flex flex-col gap-0.5">
                                            <span>
                                                {t("shipment.items.table.header.link")}
                                            </span>
                                        </div>
                                    </th>
                                )}
                                <th className="hidden sm:table-cell">
                                    <div className="inline-flex flex-col gap-0.5">
                                        <span>
                                            {t("shipment.items.table.header.warning")}
                                        </span>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {items?.map((shipmentItem, index) => (
                                <ShipmentItemTableRow
                                    data={shipmentItem}
                                    index={index + 1}
                                    boxID={boxID}
                                    key={shipmentItem.id}
                                />
                            ))}
                        </tbody>
                    </table>
                </div>
            }
        </>
    );
};

export default ShipmentItemsTable;
